// @ts-nocheck
import PropTypes from "prop-types";
import React from "react";
import className from "./PulldownList.module.scss";
import PullDownItem from "./PullDownItem";
import PullDownItemGroup from "./PullDownItemGroup";
import { getImageUrl } from "../../../commons/assets_path";

export const PulldownListOld = ({ outputs, onClickList, isSearchCompleted, isSuggestClose }) => {
  return (
    <div className={className.pulldownScroll}>
      <>
        {outputs?.map(({ operation_name, icon_type, icon_path, outputs }, i) => (
          <PullDownItemGroup
            key={i}
            title={operation_name}
            image={icon_path}
            iconType={icon_type}
            isSearchCompleted={isSearchCompleted}
            isSuggestClose={isSuggestClose}
          >
            {outputs?.map(({ id, display_name, test_value }) => (
              <PullDownItem key={id} value={display_name} onClick={onClickList}>
                <dl className={className.outputDisplay}>
                  <dt className={className.outputTitle}>
                    {
                      <img
                        src={icon_type === "service" ? icon_path : getImageUrl(icon_path)}
                        className={className.icon}
                      />
                    }
                    {display_name}
                  </dt>
                  <dd className={className.outputDescription}>
                    {test_value !== null ? test_value.replace(/\[,\]/g, ",") : ""}
                  </dd>
                </dl>
              </PullDownItem>
            ))}
          </PullDownItemGroup>
        ))}
      </>
    </div>
  );
};

PulldownListOld.propTypes = {
  outputs: PropTypes.arrayOf(
    PropTypes.shape({
      operation_name: PropTypes.string,
      operation_icon_path: PropTypes.string,
      outputs: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          display_name: PropTypes.string.isRequired,
          test_value: PropTypes.string,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  ).isRequired,
  onClickList: PropTypes.func,
  isSearchCompleted: PropTypes.bool,
  isSuggestClose: PropTypes.bool,
};
